import React, { useEffect, useState } from 'react';
import IosShareIcon from '@mui/icons-material/IosShare';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Title from '../../components/Title';
import Character from '../../components/Character';
import { Circle } from './styles';
import scrollToTop from '../../utils/scrollToTop';
import getWishlist from '../../packages/api/getWishlist';

const Wishlist = ({ className, toggleModal }) => {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    scrollToTop();
    const fetchData = async () => {
      const theWishlist = await getWishlist();
      console.log(theWishlist)
      if (Array.isArray(theWishlist)) {
        setWishlist(theWishlist);
      }
    };

    fetchData();
  }, []);

  const handleClick = () => {
    toggleModal();
  };

  return (
    <div className={className}>
      <div className="container">
        <Title>Whishlist</Title>
        <Circle>
          <IosShareIcon onClick={handleClick} style={{ color: '#f08080' }} />
        </Circle>
      </div>
      {wishlist.map((wl) => (
        <Character key={wl._id} name={wl.name.fr} image={wl.image} villagerId={wl._id} liked />
      ))}
    </div>
  );
};

Wishlist.propTypes = {
  className: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default styled(Wishlist)`
  .container {
    display: flex;
    justify-content: space-between;
  }
  .buttons__container {
    display: flex;
    justify-content: space-between;
  }
`;
